import { render, staticRenderFns } from "./change-user-con-roles.vue?vue&type=template&id=6a76c55c&scoped=true&"
import script from "./change-user-con-roles.vue?vue&type=script&lang=js&"
export * from "./change-user-con-roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76c55c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a76c55c')) {
      api.createRecord('6a76c55c', component.options)
    } else {
      api.reload('6a76c55c', component.options)
    }
    module.hot.accept("./change-user-con-roles.vue?vue&type=template&id=6a76c55c&scoped=true&", function () {
      api.rerender('6a76c55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/change-user-con-roles.vue"
export default component.exports